import React from 'react'

import SelectInput from '../../../components/form/SelectInput'
import Loading from '../../../components/layout/Loading'
import useCategories from '../../../../hocs/content/useCategories'
import { useI18N } from '../../../../libraries/i18n/hook'

type Props = {
  parentId?: string,
  onChange: (values: Record<string, string[] | string>) => void,
  values?: string[] | string
  mainCategoryId?: string | null | undefined
  name: string
  label: string
  isDisabled?: boolean
  isMulti?: boolean
}
const CategorySelectBox: React.FC<Props> = ({ name, label, mainCategoryId, values, onChange, isDisabled, isMulti = true }) => {
  const { t } = useI18N()
  const { data, isLoading } = useCategories(mainCategoryId)

  const handleChange = (ids: string[] | string) => {
    onChange({ [name]: ids })
  }

  if(isLoading) return <Loading />
  let options: Array<{ label: string, value: string }> = []
  if(!mainCategoryId) {
    options.push({ label: t('content.categories.all'), value: '' })
  }
  options = data ? options.concat(data?.map(({ name, id }) => ({ label: name, value: id.toString() }))) : []
  if(!options) return null
  let singleValue
  if(!isMulti && values) {
    singleValue = options?.find(cat => cat.value?.toString() === values?.toString())
  }
  const commonProps = { name, options, onChange: handleChange, isDisabled: isDisabled || options?.length === 0, label }
  if(isMulti) {
    return (
      <SelectInput value={options?.filter(cat => values?.includes(cat.value.toString()))} isMulti={true} {...commonProps} autoMinWidth />
    )
  }
  return <SelectInput value={singleValue} isMulti={false} {...commonProps} autoMinWidth />
}

export default CategorySelectBox
